/**
 * Internal dependencies
 */
import WMUFxExpandCollapse from "./fx/expand-collapse";

/**
 * 
 */
class WMUUtils {

	/**
	 * Retourne l'instance existante ou créé une nouvelle instance de l'objet FX pour l'élément donné.
	 */
	static fxInstance( element, fx, fxArgs = {} )
	{
		let fxInstance = null;

		switch ( fx )
		{
			case 'expand-collapse':
				return WMUFxExpandCollapse.instance( element, fxArgs );
			break;
		}

		return fxInstance;
	}

	/**
	 * 
	 */
	static clearFxInstance( element, fx )
	{
		switch ( fx )
		{
			case 'expand-collapse':
				WMUFxExpandCollapse.deleteInstance( element );
			break;
		}
	}

	/**
	 * Etend le querySelectorAll pour permettre l'utilisation de closest() dans le selecteur. Le principe de closest est de trouver
	 * le premier élément correspondant au sélecteur entre parenthèse dans les ancêtres de l'élément servant de contexte.
	 * 
	 * Example: WMUUtils.querySelectorAll( "closest( .mon-conteneur ) .ma-cible", elementDeContexte ) cherchera le premier élément
	 * avec la classe .mon-conteneur dans les ancêtres de elementDeContexte et ensuite cherchera tous les éléments ayant la classe
	 * .ma-cible à partir de l'élément.mon-conteneur.
	 * 
	 * Attention on ne peut pas utiliser "closest( .class ) > .ma-cible" parce que ça créera une querySelector à terme de type
	 * querySelector( > .ma-cible ) ce qui est considéré comme un sélecteur invalide par le moteur Javascript.
	 * Pour solutionner ce problème, utiliser "closest( .class ):scope > .ma-cible"
	 * 
	 * @param {string} selector
	 * @param {HTMLElement} closestContextElement
	 * @param {HTMLElement} globalContextElement
	 * @return {Array}
	 */
	static querySelectorAll( selector, closestContextElement, globalContextElement = document )
	{
		const nodes = [];
		let elementList;

		if ( closestContextElement && -1 !== selector.indexOf( 'closest(' ) )
		{
			selector = selector.replace( /\s/g, '' );
			const splitSelector = selector.split( ',' );

			splitSelector.forEach( ( subSelector ) =>
			{
				const closestMatch = subSelector.match( /closest\((?:[^()]|\([^()]*\))*\)/ );
				let contextElement = globalContextElement;

				if ( closestMatch )
				{
					subSelector = subSelector.replace( closestMatch[0], '' );
					const closestSelector = closestMatch[0].substring( 0, closestMatch[0].length - 1 ).replace( 'closest(', '' );

					if ( closestSelector )
					{
						const closestElement = closestContextElement.closest( closestSelector );

						if ( subSelector && closestElement )
						{
							contextElement = closestElement;
						}
						else if ( closestElement )
						{
							nodes.push( closestElement );
						}
					}
				}

				if ( subSelector )
				{
					elementList = contextElement.querySelectorAll( subSelector );
					elementList.forEach( ( element ) => nodes.push( element ) );
				}
			} );
		}

		else if ( selector )
		{
			elementList = globalContextElement.querySelectorAll( selector );
			elementList.forEach( ( element ) => nodes.push( element ) );
		}

		return nodes;
	}
	
	/**
	 * 
	 * @param {*} queryString 
	 * @returns 
	 */
	static parseQueryArgs( queryString )
	{
		const data = {};

		for ( let part of queryString.substring( queryString.indexOf( '?', queryString.lastIndexOf( '/' ) ) + 1 ).split( '&' ) )
		{
			part = part.split( '=', 2 );
			if ( 2 !== part.length ) continue;
			data[ part[0] ] = part[1];
		}

		return data;
	}

}

export default WMUUtils;
